import UserType from '@/constants/userTypeEnum';

const redirectToAuthorize = includeRedir => {
  const { VUE_APP_ACCOUNT_URL } = process.env;
  if (VUE_APP_ACCOUNT_URL) {
    let redirUrl = VUE_APP_ACCOUNT_URL;
    if (includeRedir) {
      redirUrl += `?reDir=${window.location.href}`;
    }
    window.location.href = redirUrl;
  }
};

const redirectUserType = user => {
  if (!user) {
    return;
  }

  if (user.type !== UserType.CUSTOMER) {
    window.location.href = user.defaultUrl;
  }
};

const validateUserType = async (store, next) => {
  // validate cookie is still valid, redirect if not
  // @TODO global state should have sanitized default values.
  // `Store.state.User.currentUser` defaulting to an empty
  // object implies state, when there is none; should be null|undefined.

  const doUserRedirect = user => {
    if (user.type === UserType.CUSTOMER) {
      next();
    }
    redirectUserType(user);
  };

  const { currentUser } = store.state.User;
  if (!currentUser.legacyId) {
    try {
      const loadedUser = await store.dispatch('User/loadMe');
      doUserRedirect(loadedUser);
    } catch (err) {
      redirectToAuthorize();
    }
  } else {
    doUserRedirect(currentUser);
  }
};

export default {
  redirectToAuthorize,
  redirectUserType,
  validateUserType,
};
